export default "__VITE_ASSET__CjT1oeVu__"